/**
 * Zelleditor für `OrderPosition.ContainerId`. Der Altclient schreibt die Auswahl über
 * `ValueChanged` direkt in das Modellobjekt; der lokale Zustand hält die Anzeige aktuell.
 */

import { useState } from 'react';

import { ContainerDropdown } from '@/components/inputs/ContainerDropdown';
import type { OrderPosition } from '@/types/entities';

export interface ContainerIdEditorProps {
  model: OrderPosition;
}

export function ContainerIdEditor(props: ContainerIdEditorProps) {
  const { model } = props;
  const [value, setValue] = useState(model.ContainerId);

  return (
    <ContainerDropdown
      value={value}
      onChange={(next) => {
        setValue(next);
        model.ContainerId = next;
      }}
    />
  );
}

export default ContainerIdEditor;
